var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountActivated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#669df6;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#4285f4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_KeyManageService_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.32,17.06H10v1.4h1.37v.63h1.43V12.18a3.47,3.47,0,0,0,2.67-3.34,3.42,3.42,0,1,0-4.1,3.36v2.12H9.26v1.4h2.06ZM12,2l8.21,3.42v5.63c0,5.06-3.5,9.8-8.21,11-4.71-1.15-8.21-5.89-8.21-10.95V5.42Zm0,5a1.88,1.88,0,0,1,.72,3.62A1.88,1.88,0,1,1,12,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12,19.09h.75V12.18a3.47,3.47,0,0,0,2.67-3.34A3.42,3.42,0,0,0,12,5.42V2l8.21,3.42v5.63c0,5.06-3.5,9.8-8.21,11V19.09ZM12,7a1.88,1.88,0,0,1,.72,3.62,1.09,1.09,0,0,1-.72.15Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountActivated);
export default __webpack_public_path__ + "static/media/accountActivated.b4ef79071643894b2bd4128619dcc83a.svg";
export { ForwardRef as ReactComponent };